import React, { FC } from 'react';
import { useField } from 'formik';
import { TextField, FormControlLabel, Radio } from '@mui/material';

interface TextInputProps {
  placeholder?: string;
  label?: string;
  type?: string;
  required?: boolean;
  fullWidth?: boolean;
  InputProps?: Record<string, unknown>;
  multiline?: boolean;
  minRows?: number;
  maxRows?: number;
  variant?: 'filled' | 'outlined' | 'standard';
  size?: 'small' | 'medium';
  disabled?: boolean;
  [key: string]: unknown;
}

export const TextInput: FC<TextInputProps> = ({
  placeholder,
  label,
  type,
  required,
  fullWidth,
  InputProps,
  multiline,
  minRows,
  maxRows,
  variant,
  size,
  disabled,
  ...props
}) => {
  const [field, meta] = useField(props as any);
  const errorText = meta.error && meta.touched ? String(meta.error) : '';

  return (
    <TextField
      placeholder={placeholder}
      label={label}
      type={type}
      InputProps={InputProps}
      required={required}
      fullWidth={fullWidth}
      multiline={multiline}
      minRows={minRows}
      maxRows={maxRows}
      variant={variant}
      size={size}
      disabled={disabled}
      {...field}
      helperText={errorText}
      error={!!errorText}
    />
  );
};

interface RadioInputProps {
  label: string;
  name: string;
  value?: string;
  [key: string]: unknown;
}

export const RadioInput: FC<RadioInputProps> = ({ label, ...props }) => {
  const [field] = useField(props as any);
  return <FormControlLabel {...field} control={<Radio />} label={label} />;
};
